import { render, staticRenderFns } from "./WebinarCertificado.vue?vue&type=template&id=0d979926"
import script from "./WebinarCertificado.vue?vue&type=script&lang=js"
export * from "./WebinarCertificado.vue?vue&type=script&lang=js"
import style0 from "./WebinarCertificado.vue?vue&type=style&index=0&id=0d979926&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports